<!--
    IMPORTANT: The SimilarContactModal should be implemented with this component to
    facilitate de-duplication before the resource is saved
!-->
<template>
    <div>
        <ui-autocomplete 
            :filter="filterItem"
            :label="label"
            :icon="hideIcon ? '' : icon"
            :placeholder="placeholder"
            :suggestions="options"
            :invalid="invalid||nameError.length > 0"
            :error="nameError"
            :disabled="disabled"
            v-model="internalTextValue"
            @input="updateSuggestions"
            @select="selected"
            :keys="{ label: 'primary_display_as', value: 'primary_display_as' }"
        >
            <template v-slot:suggestion="slot">
                <contact-select-option :contact="slot.suggestion"></contact-select-option>
            </template>
        </ui-autocomplete>
        <ui-textbox
            v-if="showTelephone && (!optionalTelephone || optionalTelephoneState)"
            :placeholder="primaryTelephonePlaceholder"
            v-model="primaryTelephone"
            :disabled="isExistingContact||disabled"
            :invalid="invalid||primaryTelephoneError.length > 0"
            :error="primaryTelephoneError"
            :style="{ marginLeft: (this.icon ? '2rem' : '0'), marginTop: '-.5rem' }"
            @input="updated"
        />
        <!--<ui-textbox 
            placeholder="Alternate Telephone"
            v-model="alternateTelephone"
            :disabled="isExistingContact||disabled"
            :invalid="invalid||alternateTelephoneError.length > 0"
            :error="alternateTelephoneError"
            style="margin-left: 35px;"
            @input="updated"
        />!-->
        <ui-textbox
            v-if="showEmail && (!optionalEmail || optionalEmailState)"
            :placeholder="emailPlaceholder"
            v-model="email"
            :disabled="isExistingContact||disabled"
            :invalid="invalid||emailError.length > 0"
            :error="emailError"
            :style="{ marginLeft: (this.icon ? '2rem' : '0'), marginTop: '-.5rem' }"
            @input="updated"
        />

        <div v-if="optionalTelephone || optionalEmail" :style="{ marginBottom: '1.5rem', paddingLeft: (this.icon ? '2rem' : '0'), marginTop: '-.5rem' }">
            <a href="#"
               v-if="optionalTelephone && !optionalTelephoneState"
               @click="optionalTelephoneState = true"
            >+ Add Telephone</a>
            <span v-if="optionalEmail && optionalTelephone && !optionalEmailState && !optionalTelephoneState"> | </span>
            <a href="#"
               v-if="optionalEmail && !optionalEmailState"
               @click="optionalEmailState = true"
            >+ Add Email</a>
        </div>
    </div>
</template>

<script>
    import { ContactResource, ContactSchema, ContactTypes } from '../../../classes/Api/Contact';
    import SearchesContacts from './SearchesContacts'
    import ContactSelectOption from "./ContactSelectOption.vue";
    import {PersonTitle} from "../../../../../api-clients/ts";
    import {titleCase} from "../../../filters/string";

    export default {
        components: {ContactSelectOption},
        mixins: [SearchesContacts],
        props: {
            label: {
                type: String
            },
            placeholder: {
                type: String,
                default: 'Contact Name'
            },
            primaryTelephonePlaceholder: {
                type: String,
                default: 'Primary Telephone',
            },
            emailPlaceholder: {
                type: String,
                default: 'Email',
            },
            value: {
                type: Object,
            },
            icon: {
                type: String,
                default: 'person'
            },
            hideIcon: {
                type: Boolean,
                default: false
            },
            invalid: {
                type: Boolean,
                default: false
            },
            nameError: {
                type: String,
                default: ''
            },
            primaryTelephoneError: {
                type: String,
                default: ''
            },
            emailError: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            showTelephone: {
                type: Boolean,
                default: true,
            },
            showEmail: {
                type: Boolean,
                default: true,
            },
            optionalTelephone: {
                type: Boolean,
                default: false
            },
            optionalEmail: {
                type: Boolean,
                default: false
            }
        },
        created() {
            this.reset()
        },
        data() {
            return {
                internalValue: null,
                internalTextValue: '',
                optionalTelephoneState: false,
                optionalEmailState: false,
            }
        },
        watch: {
            value: {
                handler(n, o) {
                    if (n !== o && n) {
                        this.internalValue = n
                        this.internalTextValue = n ? n.primary_display_as : ''
                    }
                },
                deep: true
            }
        },
        computed: {
            isExistingContact() {
                return !!(this.internalValue && this.internalValue.id)
            },
            primaryTelephone: {
                get() {
                    if (this.internalValue) {
                        return this.internalValue.primary_telephone
                    }
                },
                set(value) {
                    this.internalValue.primary_telephone = value
                }
            },
            alternateTelephone: {
                get() {
                    if (this.internalValue) {
                        return this.internalValue.alternate_telephone
                    }
                },
                set(value) {
                    this.internalValue.alternate_telephone = value
                }
            },
            email: {
                get() {
                    if (this.internalValue) {
                        return this.internalValue.email
                    }
                },
                set(value) {
                    this.internalValue.email = value
                }
            }
        },  
        methods: {
            reset() {
                this.clear()
            },
            selected(s) {
                this.internalValue = s

                if (this.internalValue.primary_telephone && this.optionalTelephone) {
                    this.optionalTelephoneState = true
                }

                if (this.internalValue.email && this.optionalEmail) {
                    this.optionalEmailState = true
                }

                this.updated()
            },
            clear() {
                this.internalValue = null
                this.optionalTelephoneState = false
                this.optionalEmailState = false
                this.internalTextValue = ''
                this.createNewSchema()
                this.updated()
            },
            updated(e) {
                if (e !== '' && this.internalValue && this.internalTextValue !== '' && !this.internalValue.id) {
                    let parts = this.internalTextValue.split(" ");
                    let firstName = titleCase(parts.shift())
                    let title = ''
                    let lastName

                    if (Object.keys(PersonTitle).includes(firstName)) {
                        title = firstName
                        firstName = parts.shift()
                    }

                    lastName = parts.join(" ")

                    this.internalValue.title = title
                    this.internalValue.first_name = firstName
                    this.internalValue.last_name = lastName
                    this.internalValue.primary_display_as = this.internalTextValue
                } else if (!this.internalValue.id) {
                    this.internalValue.title = ''
                    this.internalValue.first_name = ''
                    this.internalValue.last_name = ''
                    this.internalValue.primary_display_as = ''
                }

                this.$nextTick(() => {
                    this.$emit('input', this.internalValue)
                })
            },
            updateSuggestions(e) {
                if (e === '') {
                    this.clear()
                }

                this.onQueryChange(e)
                this.updated(e)
            },
            filterItem(s, q, d) {
                // We depend on the server side filtering
                return true
            },
            createNewSchema() {
                this.$set(this, 'internalValue', new ContactSchema({
                    ...this.value,
                    type: ContactTypes.LEAD
                }))

                this.internalTextValue = this.internalValue.primary_display_as

                this.updated();
            },
        }
    }
</script>